import type { Article } from "./types";

export const createAnEvent: Article = {
  slug: "create-an-event",
  published: true,
  publishedAt: "2026-10-06",
  updatedAt: "2026-10-06",
  title: {
    ro: "Cum creezi un eveniment și alegi modelul paginii",
    en: "How to create an event and pick its page design",
  },
  summary: {
    ro: "Pașii pentru a crea un eveniment de nuntă sau de botez și ce model de pagină primește fiecare tip de eveniment.",
    en: "The steps to create a wedding or baptism event, and which page design each event type gets.",
  },
  body: {
    ro: [
      { t: "p", text: "Fiecare eveniment are propria pagină publică, pe care o trimiți invitaților ca invitație digitală. Totul pornește din lista de evenimente din contul tău." },
      { t: "h2", text: "1. Creează evenimentul" },
      { t: "p", text: "Apasă „Creează eveniment”. Se deschide întrebarea „Ce eveniment organizezi?”, cu trei variante:" },
      {
        t: "ul",
        items: [
          "Nuntă: pagină pentru miri, cu numele mirilor și modelul Golden Serenity.",
          "Botez: pagină pentru botez, cu numele copilului și modelul Botez Bokeh.",
          "Nuntă și botez: ambele evenimente pe aceeași pagină, cu modelul Golden Serenity.",
        ],
      },
      { t: "p", text: "După ce alegi tipul și apeși „Continuă”, evenimentul primește câmpurile potrivite și modelul de pagină recomandat pentru tipul ales." },
      { t: "h2", text: "2. Completează detaliile" },
      { t: "p", text: "Editorul evenimentului are patru tab-uri:" },
      {
        t: "ul",
        items: [
          "„Informații Generale”: detaliile evenimentului.",
          "„Cadouri”: lista de cadouri și contribuțiile primite.",
          "„Invitați”: confirmările de prezență (RSVP) și data limită.",
          "„Pagina Eveniment”: designul paginii publice și opțiunile de confidențialitate.",
        ],
      },
      { t: "h2", text: "3. Publică și distribuie pagina" },
      { t: "p", text: "Când pagina este gata, o publici din editor cu „Publică Eveniment”. Apoi distribui link-ul prin WhatsApp, email sau cod QR. Poți folosi pagina și împreună cu invitații tipărite, adăugând pe ele codul QR." },
      { t: "p", text: "Adresa paginii este generată automat pe baza numelui și a datei evenimentului. Un URL personalizat este disponibil doar pentru anumite pachete." },
    ],
    en: [
      { t: "p", text: "Every event has its own public page, which you send to guests as a digital invitation. Everything starts from the events list in your account." },
      { t: "h2", text: "1. Create the event" },
      { t: "p", text: "Click “Create event”. You are asked “What are you planning?”, with three options:" },
      {
        t: "ul",
        items: [
          "Wedding: a page for the couple, with the bride and groom names and the Golden Serenity design.",
          "Baptism: a page for the baptism, with the baby's name and the Botez Bokeh design.",
          "Wedding & baptism: both events on the same page, using the Golden Serenity design.",
        ],
      },
      { t: "p", text: "Once you pick the type and click “Continue”, the event gets the matching fields and the page design recommended for that type." },
      { t: "h2", text: "2. Fill in the details" },
      { t: "p", text: "The event editor has four tabs:" },
      {
        t: "ul",
        items: [
          "“General Information”: the event details.",
          "“Gifts”: the gift list and the contributions you receive.",
          "“Guests”: attendance confirmations (RSVP) and the cutoff date.",
          "“Event Landing Page”: the public page design and privacy options.",
        ],
      },
      { t: "h2", text: "3. Publish and share the page" },
      { t: "p", text: "When the page is ready, publish it from the editor with “Publish Event”. Then share the link via WhatsApp, email or QR code. You can also use the page alongside printed invitations by adding the QR code to them." },
      { t: "p", text: "The page address is generated automatically from the event name and date. A custom URL is only available on some plans." },
    ],
  },
};
